import React from 'react'

const SvgRoadFilled = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width='1em' height='1em' viewBox='0 0 24 24' {...props}>
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M11 7.5h2V3h1.733c1.029 0 1.925.703 2.175 1.704l4.058 14.898A1.126 1.126 0 0119.88 21H13v-4.5h-2V21H4.121a1.125 1.125 0 01-1.087-1.398L7.092 4.704A2.243 2.243 0 019.267 3H11v4.5zm2 2.25h-2v4.5h2v-4.5z'
    />
  </svg>
)

export default SvgRoadFilled
